import codeLevelDesc from './ksteel_code_level_desc.json';
import companyCodeLevelDesc from './ksteel_company_code_level_desc.json';
import asIsToBeMsg from './ksteel_parsed_asis_tobe.json';

// 영문 문구 조회·조립 (영문 없으면 항목 단위 국문 폴백) — report-supply-text.cjs
const {localized, complianceRateMsgEn, assessmentRateMsgEn, codeComplianceHeadEn} = require('../report-supply-text.cjs');


function convertSubCodeToCode(sub_code) {
    // 예: C1-2.3 → C-1-2
    const match = sub_code.match(/^([A-Z])(\d+)-(\d+)\./);
    if (!match) return sub_code; // 패턴이 맞지 않으면 원본 반환
    const [, area, first, second] = match;
    return `${area}-${first}-${second}`;
}
function rgbaToRgb(rgbaArray, background = [255, 255, 255]) {
    const [r, g, b, a] = rgbaArray;
    const [bgR, bgG, bgB] = background;
    
    // 알파 블렌딩 공식을 적용합니다.
    // 최종색 = (소스색 * 알파) + (배경색 * (1 - 알파))
    const finalR = Math.round((1 - a) * bgR + a * r);
    const finalG = Math.round((1 - a) * bgG + a * g);
    const finalB = Math.round((1 - a) * bgB + a * b);
    
    return [finalR, finalG, finalB];
}

const summaryMsg = {
    // en 은 영문, 그 외(ko·ca …)는 국문. (전에는 ko 가 아니면 빈 문자열이라 영문 보고서에서 문장이 통째로 비었다)
    complianceRateMsg: (locale, companyName, levelData) => {
        if (locale === 'en') return complianceRateMsgEn(companyName, levelData);
        const { total, processedTotalCodeData} = levelData;

        let msg = `${companyName} 기업의 ESG Code 준수율은 ${total.total_compliance}% (${processedTotalCodeData.compliance}/${processedTotalCodeData.total})입니다. `;
        if(processedTotalCodeData.D > 0){
            msg += `매우 미흡으로 평가된 ${processedTotalCodeData.D}개 Code에 대해 핵심 리스크 사항을 파악하고 개선하려는 노력이 필요합니다.`;
        }

        return msg;
    },
    assessmentRateMsg: (locale, companyName, processedSubData, reliability) => {
        if (locale === 'en') return assessmentRateMsgEn(companyName, processedSubData, reliability);

        let msg = '평가 과정에서 \'모름\' 응답이 다수 선택되거나 답변의 질적 수준이 미흡하여 평가자의 판단이 곤란한 경우, 해당 응답은 유효하지 않은 것으로 간주되어 평가 신뢰도가 낮게 결정됩니다.';
        msg += `\n${companyName} 기업의 경우 평가 대상 ${processedSubData.total}개 문항 중 ${processedSubData.unknown}개 문항에 대해 유효한 평가가 불가하여 신뢰도 수준이 '${reliability}'로 정의되었습니다.`;

        return msg;
    },
};

const mapCampaignIdToCompanySize = {
    546: '대기업',
    547: '중기업',
    548: '소기업',
    549: '사내도급',
    // 넥센타이어 2026 (df_campaigns 실측 이름 기준, 2026-09-03)
    566: '대기업',
    567: '중기업',
    568: '소기업',
};


const codeResult = {
    mapCodeToConduct: {
        'A-1-1': '모든 근로자와 정당한 계약을 맺고, 적절한 수준의 임금을 보장해야 한다.',
        'A-1-2': '모든 근로자의 근로시간 및 초과근무는 국제기준과 현지법규 기준을 충족해야 한다.',
        'A-1-3': '모든 근로자에게 적절한 휴식 및 휴가를 제공하고, 이동의 자유를 보장해야 한다.',
        'A-1-4': '아동노동 및 강제노동을 예방하기 위한 강력한 조치를 취해야 한다.',
        'A-1-5': '납품 제품이 최종 철강제품에 포함되는 경우, 분쟁 및 인권 침해에 활용될 수 있는 광물의 채굴, 사용, 유통을 근절해야 한다.',
        'A-2-1': '성별, 인종, 종교 등 어떠한 이유로도 차별을 금지하고, 모든 근로자에게 동등한 기회를 제공해야 한다.',
        'A-2-2': '신체적, 정신적 괴롭힘 및 폭력 등 모든 비인도적 행위는 엄격히 금지한다.',
        'A-3-1': '국제기준에 부합하는 안전하고 건강한 작업 환경을 제공해야 한다.',
        'A-3-2': '산업재해 예방을 위한 체계적인 관리가 이루어져야 한다.',
        'A-3-3': '사내도급 및 사업장 내에서 근로하는 협력사에 대한 적절한 안전관리를 이행해야 한다.',
        'B-1-1': '(관련된 환경부하가 존재하는 경우) 자원의 효율적 사용과 절약을 위하여 노력하여야 한다.',
        'B-1-2': '(관련된 환경부하가 존재하는 경우) 폐기물 관리 및 재활용을 적절히 이행해야 한다.',
        'B-2-1': '(관련된 환경부하가 존재하는 경우) 유해물질 배출을 최소화 하기 위한 조치를 이행해야 한다.',
        'B-2-2': '(관련된 환경부하가 존재하는 경우) 물·대기·토양 오염 방지를 위해 적절히 관리하여야 한다.',
        'B-3-1': '기후변화의 심각성을 인지하고 온실가스 배출을 모니터링하여야 한다.',
        'B-3-2': '온실가스 감축 목표를 설정하고 감축을 이행해야 한다.',
        'B-3-3': '납품 제품이 최종 철강제품에 포함되는 경우, 내재 탄소배출량을 산정하고 저감을 위해 노력해야 한다.',
        'C-1-1': '인권, 환경 관련 법규를 준수하기 위해 노력해야 한다.',
        'C-1-2': '적절한 수준의 내부 감사 및 윤리 통제를 실시해야 한다.',
        'C-2-1': 'ESG 관련 데이터를 투명하게 공개해야 한다.',
        'C-2-2': 'ESG 관련 점진적 개선을 위해 고충 접수 채널 운영 및 모니터링을 실시해야 한다.',
        'C-3-1': '모든 협력사 및 하위 공급망에 본 Code of Conduct 준수를 요구해야 한다.',
        'C-3-2': '공급망 전반에 걸친 ESG 리스크를 식별하고 적절히 조치해야 한다.',
        // 넥센타이어 CoC 신규 지표 3종 (2026-09-02 확정본 엑셀 D열 원문)
        'A-1-6': '근로자의 결사의 자유와 단체교섭권을 보장해야 한다.',
        'B-4-1': '생물다양성을 보전하고 동물 복지를 존중하기 위해 노력해야 한다.',
        'C-4-1': '개인정보 및 기밀정보를 보호하고 지적재산권을 존중해야 한다.',
    },
    mapCodeToConductDesc: {
        'A-1-1': '기업은 모든 근로자와 정당한 근로계약을 체결하여 고용 안정성을 보장하고 적정 임금을 제공하는 것은 직무를 지속할 수 있는 조건을 마련하고 작업장 안전을 확보하는 데 필수적입니다. 아울러 이러한 조치는 숙련 인력의 이탈을 막고, 협력사 및 하도급 업체를 포함한 공급망 전반에서 책임 있는 인권 관리 체계를 구축하는 기반이 됩니다.',
        'A-1-2': '법정 근로시간 기준을 위반하거나 자발성이 결여된 초과근무는 만성피로와 집중력 저하를 야기하여 중대재해 발생 위험을 현저히 증가시키는 동시에, 근로자의 건강권과 휴식권을 침해합니다. 따라서, 국제노동기구(ILO) 기준과  근로기준법에 따르도록 근로시간을 관리하고 초과근무 시 적정 가산수당 지급하여 근로자의 인권을 보장해야 합니다.',
        'A-1-3': '근로기준법에 따른 휴게시간 보장과 연차휴가 사용권의 실질적 보장은 산업재해 예방과 생산성 유지의 필수 조건입니다. 또한, 외국인 근로자와 기숙사 거주 근로자를 포함한 모든 인력에 대해 외출 제한 등 이동의 자유를 침해하는 관행을 철폐하고, 국제노동기구(ILO) 강제근로 금지 협약과 인신매매 방지 의정서에 부합하는 인권 보호 체계를 구축하여야 합니다',
        'A-1-4': '글로벌 ESG 스탠다드는 아동노동이나 강제노동 발생 시 위험성과 인권침해를 우려합니다.  특히 하도급업체를 통한 외국인 근로자 채용 과정에서 신원확인 부실, 여권 강제보관 등의 관행은 의도와 무관하게 현대적 노예제 상황을 조성할 위험이 높습니다. EU CSDDD에 따른 전 사업영역 인권 리스크 관리를 위해서는 체계적 기준을 기반으로 정기적 현장 점검 등의 방지 활동이 필요합니다.',
        'A-1-5': '철강제품 중 고합금강과 표면처리강에는 주석(Tin), 텅스텐(Tungsten), 탄탈륨(Tantalum), 금(Gold) 등 3TG 광물이 포함되는 경우가 있으며, 콩고민주공화국 등 분쟁 지역에서 불법 채굴되어 무장단체 자금원으로 유용될 우려가 있습니다. 코발트, 운모 등 확대된 책임광물까지 포함하도록 체계적인 광물 관리체계를 운영하여 인권침해 및 환경파괴와 연관된 원재료가 공급망에 유입되는 것을 차단해야 합니다.',
        'A-2-1': '철강 산업은 전통적으로 남성 중심의 고강도 산업으로 인식되어 여성, 외국인, 고령자 등에 대한 구조적 편견과 차별적 관행이 고착화되어 있는 업종입니다. 그러나 급속한 고령화와 인력 다변화 등 산업 패러다임 전환 시대에서 인종, 성별, 종교, 국적 등을 이유로 한 차별을 철폐하고 역량 기반의 공정한 채용·승진 시스템을 구축하는 것은 경쟁력 확보를 위한 필수 조건입니다. 포용적 조직문화 구축을 통해 다양한 배경의 우수 인재를 확보하고, 대외적으로 기업의 책임경영 의지를 전달할 수 있습니다.',
        'A-2-2': '철강 산업은 남성 중심의 위계적 조직문화로 인해, 직장 내 괴롭힘, 성희롱, 언어적·신체적 폭력 등 비인도적 행위 발생 위험이 상존하는 업종입니다. 비인도적 행위는 개인의 존엄성 훼손뿐 아니라 조직 전체의 안전 문화와 생산성에 심각한 악영향을 초래합니다. 비인도적 행위 명시적 금지 규정 수립, 피해자 보호 및 가해자 징계 절차 마련을 통해 모든 근로자의 인간적 존엄성을 보장하는 작업환경 조성이 필수적입니다.',
        'A-3-1': '기업은 산업안전보건법과 중대재해처벌법에 따른 포괄 안전·보건 인프라 구축은 물론, 사업장 내 모든 인력에 대해 동등한 수준의 안전 교육과 보호 조치를 적용하여 생명 존중 문화를 확산해야 합니다.',
        'A-3-2': '안전 사고는 사후 대응보다 사전 예방 중심의 구조적 안전관리 시스템 구축이 근로자 생명 보호의 핵심 과제입니다. 산업재해 예방은 안전관리 부서의 개별 업무를 넘어 경영진부터 현장 작업자까지 전 조직이 참여하는 통합적 리스크 관리 체계로 운영되어야 하며, 법정 의무사항 이행과 더불어 사고 발생 시 근본원인 분석, 합동 안전보건위원회 운영 등 선제적 예방 시스템을 통해 잠재된 위험요소를 사전에 식별하고 제거하는 것이 필수적입니다',
        'A-3-3': '철강 산업은 특성상 정비, 운반, 청소, 보수 등 다양한 작업이 외주화 및 사내도급 형태로 수행됩니다. 협력사 근로자들은 주로 고위험·비정형 작업에 투입되나 원청 대비 상대적으로 미흡한 안전교육, 보호장비 지급, 작업 관리감독을 받아 산업재해 위험에 더욱 취약하게 노출됩니다. 따라서 중대재해처벌법과 산업안전보건법상 원청 책임 원칙에 따라 협력사 및 사내도급 근로자에 대해서도 자사 직원과 동등한 수준으로 관리하는 안전관리 체계를 구축해야 합니다.',
        'B-1-1': '철강 산업은 철광석, 석탄, 고철 등 대량의 원료와 전력, 연료 등 막대한 에너지, 그리고 냉각수, 공업용수 등을 집약적으로 소비하는 대표적 자원집약형 산업입니다. 원가 경쟁력 확보와 동시에 환경부하 최소화를 위해서는 원료 투입 효율성 향상, 공정 최적화, 에너지 손실 저감 등 체계적인 자원 효율성 개선 노력이 필요합니다. 자원 소비가 발생하는 기업에 한해 적용되며, 실질적인 절감 활동의 실행 여부를 평가합니다.',
        'B-1-2': '철강 산업은 슬래그, 분진, 폐수오니, 포장재, 폐유 등 다양한 형태의 산업폐기물을 배출합니다. 폐기물의 부적절한 분리·보관·처리는 환경 오염은 물론 폐기물관리법 위반으로 직결될 수 있습니다. 고로 슬래그와 전기로 분진 등 주요 부산물을 재활용하는 것은 순환경제 구현 측면에서 매우 중요합니다. 사업장에서 발생하는 폐기물이 종류별 특성에 맞게 적법하게 분류·저장·처리되는지, 재활용률을 제고하는지, 또한 폐기물 처리·운반업체에 대한 적법성 모니터링이 이뤄지고 있는지를 평가합니다.',
        'B-2-1': '철강 산업의 제강, 열처리, 도금, 도장, 세척 공정에서는 질소산화물(NOx), 황산화물(SOx), 염산·황산, 휘발성유기화합물(VOCs), 분진 등 다양한 유해물질이 발생합니다. 이러한 유해물질의 무단 배출은 대기, 수질, 토양의 복합적 환경오염을 초래하며, 사업장 인근 지역주민과 근로자의 호흡기 질환 등 질병 발생 위험이 현저히 증가합니다. 따라서 유해물질 배출 가능성이 있는 공정을 보유한 경우 집진기, 세정설비 등 유해물질 저감설비 설치, 정기적 점검·정비, 배출허용기준 엄격 준수를 평가합니다.',
        'B-2-2': '철강 산업은 고온 열처리, 세척·산세, 도장, 냉각 등 공정 특성상 폐수, 폐열, 폐가스, 토양오염 유발물질이 동시다발적으로 발생합니다. 특히 산세공정의 폐산 누출, 압연유 유출, 원료 야적장 침출수 등은 토양 및 지하수에 심각한 오염을 초래하여 장기적인 환경복구 비용과 법적 책임으로 이어질 수 있습니다. 따라서 오염 발생 공정 보유 대상 오염 방지를 위한 사전 예방적 관리체계 보유 여부와 기술적 오염방지 설비 보유 및 정기 점검·정비 여부, 환경사고 대응체계의 실행 여부를 평가합니다.',
        'B-3-1': '철강 산업은 세계적으로 가장 에너지 집약적인 업종 중 하나로, 고로·전기로·열처리·운송 등 전 공정에서 이산화탄소(CO₂), 메탄(CH₄), 이산화질소(N₂O) 등 온실가스가 대량 배출됩니다. 국가 단위 탄소중립 목표 강화와 EU 탄소국경조정제도(CBAM) 등 규제 대응을 위해 기업은 자사 온실가스 배출 현황에 대해 정확한 실태를 파악해야 합니다. 직접 배출(Scope 1)과 간접 배출(Scope 2)을 체계적으로 모니터링 및 데이터 관리하여 향후 탄소감축 목표 설정 및 이행전략 수립의 기반을 마련할 수 있습니다.',
        'B-3-2': '철강 산업은 국가 온실가스 총배출량의 약 10% 이상을 차지하는 대표적인 탄소다배출 업종입니다. 기후위기에 대응하여 EU CBAM, RE100, Net-Zero 선언 등 글로벌 규제가 강화됨에 따라, 단순한 배출량 측정을 넘어 중장기 감축목표의 설정과 이행 노력이 요구되고 있습니다. 이를 위해 전기로 효율 개선, 재생에너지 전력 사용 확대, 설비 교체 및 공정 개선 등이 주요 감축 수단으로 간주됩니다. 단순한 온실가스 배출 모니터링을 넘어, 기업의 실질적인 감축 의지와 감축 활동 실행 여부가 평가됩니다.',
        'B-3-3': '‘내재 탄소배출량(Embedded Carbon)’은 부품이나 소재가 생산되는 전 과정에서 발생하는 온실가스를 의미합니다. 철강 산업은 자동차, 조선, 건설 등 다양한 산업에 소재를 공급하는 주요 업종으로, 고객사는 납품받은 부품이 최종 제품의 전체 탄소배출량에 얼마나 기여하는지 파악하고자 합니다. 이에 따라 Tier 1 협력사뿐만 아니라 중소 협력사도 자사 제품 단위의 탄소배출량을 산정하고 개선 노력을 수행해야 하며, 이러한 활동은 향후 납품 조건에 직접적인 영향을 미칠 수 있습니다.',
        'C-1-1': '철강 산업은 고위험 공정 수행, 대규모 에너지 사용, 화학물질 취급, 외주 인력 활용 등으로 인해 산업안전, 노동인권, 환경 분야에서 복잡한 법적 요건의 대상입니다. 최근 공급망 차원의 법규 준수 책임이 강조되면서, 단순 준법을 넘어 적극적인 리스크 예방 체계와 정기 점검·교육·보고 체계가 중요한 평가 요소로 부각되고 있습니다. 산업안전보건법, 환경정책기본법, 화학물질관리법, 근로기준법 등 인권·환경 관련 법령과 규정에 대한 조직 차원의 인식, 체계, 실행 수준을 종합적으로 점검합니다.',
        'C-1-2': '철강 산업은 원재료 조달부터 생산, 운송, 판매에 이르는 공급망이 방대하며, 고비용·고위험 특성이 강해 부당한 이익 취득, 비윤리적 계약, 불공정 거래, 회계 왜곡 등의 리스크가 상존합니다. 특히 글로벌 고객사와의 거래 및 해외 사업 확장에 따라 윤리경영, 내부통제, 부패방지 시스템에 대한 요구 수준이 점차 높아지고 있습니다. 사업장의 내부 감사 체계와 윤리 기준의 수립·실행 여부, 법적·윤리적 위반 발생 시 대응 체계를 확인하며, 단순한 선언을 넘어 운영의 실효성을 평가합니다.',
        'C-2-1': '철강 산업은 VSME 기준에서 요구하는 최소 ESG 정보는 공개하여 기업의 신뢰성과 책임성을 확보할 것이 권장됩니다. 초기 단계에서는 핵심 성과지표(KPI)나 주요 성과 중심으로 단계적으로 공개할 수 있으며, 점차 GRI, ESRS 등 국제 공시 기준에 맞춰 정보를 확장해 나가는 것이 바람직합니다. 이러한 공개 활동은 단순한 정보 제공을 넘어, 철강산업의 특성을 반영한 ESG 관리 체계의 실효성을 보여주는 중요한 수단입니다.',
        'C-2-2': '철강 산업은 ESG 관련 리스크와 기회가 복합적으로 존재합니다. 이에 따라서 정기적인 모니터링 체계를 구축하여 기업 전반의 활동을 체계적으로 점검하고 개선점을 도출하여야 합니다. 다수의 글로벌 기준에서는 이해관계자의 의견과 피드백을 효과적으로 수렴하기 위해 고충 접수 채널을 운영할 것을 권고하며 이는 ESG 관리 체계의 실효성과 기업의 책임성을 강화하는 핵심 요소입니다.',
        'C-3-1': '철강 산업은 복잡한 다단계 공급망 구조를 가지고 있으며,  ESG 관련 리스크는 1차 협력사보다 오히려 2·3차 하청업체나 원재료 공급 단계에서 더욱 빈번하게 발생합니다. 이에 따라 기업은 전 공급망 파트너에게도 동일한 ESG 기준 적용을 요구하고, 이행 여부를 모니터링해야 합니다. 특히 글로벌 완성차 및 조선업계 등 주요 고객사들이 공급망 전체의 ESG 리스크를 사업자의 직접적 책임으로 평가하기에 공급망 ESG 관리는 철강업계의 지속가능한 경쟁력 확보를 위한 필수과제입니다.',
        'C-3-2': '철강산업의 공급망은 철스크랩, 합금, 석탄, 광물 등 원재료부터 표면처리, 운송, 포장 등 다양한 외부 파트너로 구성되어 있으며, 이 과정에서 인권 침해, 산업재해, 환경오염, 윤리 위반 등과 같은 ESG 리스크가 다단계로 잠재되어 있습니다. 글로벌 ESG 실사 기준에 부합하는 리스크 기반 접근법(RBA: Risk-Based Approach)을 바탕으로 공급망 전체 대상 리스크의 발생 가능성을 사전에 식별하고, 조기경보 시스템 또는 개선 조치 절차를 마련하여 운영하는지를 평가합니다.',
        // 넥센타이어 CoC 신규 지표 3종 (2026-09-14 '결과보고서_미흡지표_표현_지표추가 Ver' 엑셀 D열 원문)
        'A-1-6': '글로벌 ESG 스탠다드는 결사의 자유와 단체교섭권을 ILO 핵심협약 제87호·제98호에 기반한 노동기본권으로 규정합니다. 노동조합 조직·가입을 제한하거나 단체활동을 이유로 불이익을 부여하는 관행은 국제 인권규범 위반으로 직결되며, 공급망 실사에서 우선 점검 항목으로 다루어집니다. EU CSDDD와 OECD 실사 지침은 노동조합이 부재한 사업장에서도 근로자 대표를 통한 실질적 협의 채널을 요구하므로, 방침 수립과 함께 정기 협의체 운영 실적을 확보하는 것이 필요합니다.',
        'B-4-1': '글로벌 ESG 스탠다드는 기후변화와 함께 자연자본 손실을 주요 재무 리스크로 인식하고 있습니다. 특히 천연고무 등 원자재 조달 과정에서 발생하는 산림전용과 서식지 훼손은 규제 리스크로 전이될 수 있으며, 사업장이 법정 보호구역이나 생태 민감지역에 인접한 경우 인허가 및 지역사회 갈등 요인이 됩니다. TNFD와 GRI 304는 보호구역 현황 파악, 생물다양성 영향·의존도 평가, 결과의 대외 공개를 요구하므로, 방침 수립부터 모니터링과 공시까지 연계된 관리 체계가 필요합니다.',
        'C-4-1': '글로벌 ESG 스탠다드는 정보보호와 지적재산권 존중을 기업 지배구조 및 윤리경영의 핵심 요소로 다룹니다. 협력사가 발주사의 설계 도면, 공정 기술, 고객 정보를 취급하는 과정에서 발생하는 유출 사고는 공급망 전체의 신뢰도를 훼손하며, 국내 개인정보보호법과 EU GDPR은 위반 시 매출액 기반의 과징금을 부과합니다. 정보보안 정책 수립과 접근 권한 관리, 합법적 근거에 기반한 개인정보 처리, 타인의 지적재산권 침해 방지 체계가 함께 요구됩니다.'
    },
    // locale === 'en' 이면 code_desc·ev_code_desc 에 영문(Code명·등급 라벨)을 넘겨받는다. 그 외 언어는 국문.
    mapCodeComplianceMsg: ({locale, company_name,code, code_desc,ev_code, ev_code_desc}) => {
        let msg;
        if (locale === 'en') {
            msg = codeComplianceHeadEn(company_name, code_desc, ev_code_desc);
        }
        else {
            msg = `${company_name} 기업의 '${code_desc}'의 코드 준수 수준은 `;
            if(ev_code === 'A') {
                msg +=  `'${ev_code_desc}'로 평가되었습니다. `;
            }
            else {
                msg +=  `'${ev_code_desc}'으로 평가되었습니다. `;
            }
        }
        if(code == null || ev_code == null || ev_code === 'N')
            return msg;
        msg += localized(locale, companyCodeLevelDesc[code][ev_code], 'companyLevelDesc', code, ev_code);

        return msg;
    },
    mapCodeLevelDesc: codeLevelDesc,
    evAsIsToBeMsg: asIsToBeMsg
};

// 넥센(NEXTIER-*) 보고서 전용 업종 중립 문구 — 위 코드 제목·설명은 철강협회 문구가 원본이라 '철강 산업은' 등이 남아 있다.
// 기본 문구에서 [찾을 구절, 바꿀 구절] 만 교체해 나머지 문장은 원문 그대로 따라간다.
// 출처: 김동영님 '보고서_철강표기_수정요청목록_국,영문.xlsx' (#넥센타이어-공급망, 2026-09-30) 국문 20행 · 영문 20행.
// CO₂ 등 아래첨자는 PDF 폰트에 글리프가 없어 빠지므로 CO2 로 적는다. 구절이 안 맞으면 조용히 원문이 남으므로
// tests/report-supply-nexen-wording.test.cjs 가 철강 표기 0건을 지킨다.
const NEXEN_WORDING = {
    ko: {
        conduct: {
            'A-1-5': [['최종 철강제품', '최종 제품']],
        },
        conductDesc: {
            'A-1-5': [['철강제품 중 고합금강과 표면처리강에는', '전자부품, 합금, 표면처리 제품 등에는']],
            'A-2-1': [['철강 산업은', '제조업은']],
            'A-2-2': [['철강 산업은', '제조업은']],
            'B-1-1': [['철강 산업은 철광석, 석탄, 고철 등 대량의 원료와', '제조업은 원료와']],
            'B-1-2': [
                ['철강 산업은 슬래그, 분진,', '제조업은 분진,'],
                ['고로 슬래그와 전기로 분진 등 주요 부산물을', '공정 부산물을'],
            ],
            'B-2-1': [['철강 산업의 제강, 열처리, 도금, 도장, 세척 공정에서는', '제조업의 열처리, 도금, 도장, 세척 등 공정에서는']],
            'B-2-2': [
                ['철강 산업은', '제조업은'],
                ['산세공정의 폐산 누출, 압연유 유출,', '화학물질 누출, 유류 유출,'],
            ],
            'B-3-1': [[
                '철강 산업은 세계적으로 가장 에너지 집약적인 업종 중 하나로, 고로·전기로·열처리·운송 등 전 공정에서 이산화탄소(CO₂), 메탄(CH₄), 이산화질소(N₂O) 등 온실가스가 대량 배출됩니다.',
                '제조업은 에너지 집약적인 업종으로, 생산·열처리·운송 등 전 공정에서 이산화탄소(CO2), 메탄(CH4), 아산화질소(N2O) 등 온실가스가 배출됩니다.',
            ]],
            'B-3-2': [
                ['철강 산업은 국가 온실가스 총배출량의 약 10% 이상을 차지하는 대표적인', '제조업은 대표적인'],
                ['전기로 효율 개선', '설비 효율 개선'],
            ],
            'B-4-1': [['천연고무 등 원자재', '원자재']],
            'C-1-1': [['철강 산업은', '제조업은']],
            'C-1-2': [['철강 산업은', '제조업은']],
            'C-2-2': [['철강 산업은', '제조업은']],
            'C-3-1': [
                ['철강 산업은', '제조업은'],
                ['글로벌 완성차 및 조선업계 등 주요 고객사들이', '글로벌 주요 고객사들이'],
                ['철강업계의 지속가능한', '기업의 지속가능한'],
            ],
            'C-3-2': [['철강산업의 공급망은 철스크랩, 합금, 석탄, 광물 등 원재료부터', '제조업의 공급망은 원재료 공급부터']],
        },
    },
    en: {
        conduct: {
            'A-1-5': [['final steel products', 'final products']],
        },
        conductDesc: {
            'A-1-5': [['High-alloy steel and surface-treated steel may contain', 'Electronic components, alloys and surface-treated products may contain']],
            'A-2-1': [['The steel industry', 'The manufacturing industry']],
            'A-2-2': [['the steel industry', 'the manufacturing industry']],
            'B-1-1': [
                ['The steel industry', 'The manufacturing industry'],
                ['raw materials such as iron ore, coal and scrap,', 'raw materials,'],
            ],
            'B-1-2': [
                ['The steel industry', 'The manufacturing industry'],
                ['including slag, dust,', 'including dust,'],
                ['major by-products such as blast furnace slag and electric arc furnace dust', 'major process by-products'],
            ],
            'B-2-1': [['Steelmaking, heat treatment, plating, painting and cleaning processes in the steel industry', 'Heat treatment, plating, painting and cleaning processes in the manufacturing industry']],
            'B-2-2': [
                ['the steel industry', 'the manufacturing industry'],
                ['leakage of spent acid from pickling processes, spillage of rolling oil', 'leakage of chemical substances, spillage of oil'],
            ],
            'B-3-1': [[
                'The steel industry is one of the most energy-intensive sectors in the world, emitting large volumes of greenhouse gases such as carbon dioxide (CO₂), methane (CH₄) and nitrous oxide (N₂O) across all processes, including blast furnaces, electric arc furnaces, heat treatment and transport.',
                'The manufacturing industry is an energy-intensive sector, emitting greenhouse gases such as carbon dioxide (CO2), methane (CH4) and nitrous oxide (N2O) across all processes, including production, heat treatment and transport.',
            ]],
            'B-3-2': [
                ['The steel industry is a representative carbon-intensive sector accounting for more than approximately 10% of national total greenhouse gas emissions.', 'The manufacturing industry is a representative carbon-intensive sector.'],
                ['improving electric arc furnace efficiency', 'improving facility efficiency'],
            ],
            'B-4-1': [['raw materials such as natural rubber may', 'raw materials may']],
            'C-1-1': [['the steel industry', 'the manufacturing industry']],
            'C-1-2': [['The steel industry', 'The manufacturing industry']],
            'C-2-2': [['The steel industry', 'The manufacturing industry']],
            'C-3-1': [
                ['The steel industry', 'The manufacturing industry'],
                ['major customers such as global automotive and shipbuilding companies assess', 'major global customers assess'],
                ['securing sustainable competitiveness in the steel industry.', 'securing the company’s sustainable competitiveness.'],
            ],
            'C-3-2': [
                ['the steel industry', 'the manufacturing industry'],
                ['from raw materials such as steel scrap, alloys, coal and minerals through to', 'from raw material supply through to'],
            ],
        },
    },
};

// kind: 'conduct' | 'conductDesc'. en 이 아닌 언어는 국문 문구가 나가므로 국문 교체를 쓴다.
function nexenWording (lang, kind, code, text) {
    const pairs = NEXEN_WORDING[lang === 'en' ? 'en' : 'ko'][kind][code] || [];
    return pairs.reduce((acc, [from, to]) => acc.split(from).join(to), text);
}

export {summaryMsg, rgbaToRgb,convertSubCodeToCode, mapCampaignIdToCompanySize, codeResult, nexenWording, NEXEN_WORDING};
